import { ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'
import { useIsActive } from 'modules/header/hooks/use-is-active'

export function TopMenuItem({
  icon,
  name,
  href,
  ignoreBasePath = false,
  className,
  activeClassName,
  ...rest
}: {
  icon: ReactNode
  name: ParseKeys
  href: string
  ignoreBasePath?: boolean
  className?: string
  activeClassName?: string
}): ReactNode {
  const isActive = useIsActive(href)
  const { t } = useTranslation()

  const classes = twMerge(
    'hidden h-8 shrink-0 items-center gap-1.5 rounded-md px-2 text-base font-medium transition-colors outline-none hover:bg-bg-tertiary focus-visible:focus-ring-primary lg:flex',
    className,
    isActive && twMerge('bg-bg-tertiary text-text-primary', activeClassName),
  )

  if (ignoreBasePath) {
    return (
      <a href={href} className={classes} {...rest}>
        {icon}
        <span>{t(name)}</span>
      </a>
    )
  }

  return (
    <Link href={href} className={classes} {...rest}>
      {icon}
      <span>{t(name)}</span>
    </Link>
  )
}
